import classNames from "classnames";
import React from "react";

import styles from "./scores-disclaimer.module.scss";
import {UseTerms} from "../composers/composer-plugins/use-terms";
import {
  BrandReviewOffersO18ImageRequestParams
} from "../../../containers/betting-container/pages/brand-review-page/components/offers/models/brand-review.offers-o18.image-request-params";
import {COLORS} from "../../app/consts/colors";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {SVGImage} from "../image/svg-image";

export const ScoresDisclaimer = UseTerms()(({i18n, bookmakers, className}) => {
  if (!bookmakers || bookmakers?.length === 0) {
    return null;
  }

  const string = `${i18n.WEB_BOOKIE_COMPLIANCE}${bookmakers?.length === 1 ? i18n[`WEB_BOOKIE_LICENSE_${bookmakers[0]}`] || '' : ''}`;

  const imageProps = {
    className: classNames(styles.icon),
    src: new BrandReviewOffersO18ImageRequestParams(16, 16),
    color: COLORS.textPrimary,
    fillcolor: useThemeColor(COLORS.textPrimary)
  }

  return <div className={classNames(className, styles.container)}>
    <SVGImage {...imageProps}/>
    {string}
  </div>
});